export default __webpack_public_path__ + "static/media/downArrow.1c2e420b.svg";